import * as technicianGroups from './technicianGroups';
import * as technicians from './technicians';

const Actions = {
  ...technicianGroups,
  ...technicians,
};

export default Actions;
